/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import http from '../common/http-auth';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllBulkEmail = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/bulkcampaign/all?clientId=${clientId}` : '/bulkcampaign/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const uploadBulkCampaignCsv = async (data: FormData | any) : Promise<any> => {
  try {
    if (data instanceof FormData) {
      // Case 1: Uploading file
      const clientIdEntry = data.get("clientId");
      const clientId = typeof clientIdEntry === 'string' ? clientIdEntry : '0';
      return await http.post(`/bulkcampaign/uploadcsv?clientId=${clientId}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    } else {
      // Case 2: Already uploaded, send identifiers + lists as query params
      const {
        BulkCampaignDataIdentifier,
        sourceCSVFileName,
        clientId,
        uploadedCSVFileName,
        selectedSeedList,
        selectedSuppressionList,
         id
      } = data;

      const query = new URLSearchParams({
        BulkCampaignDataIdentifier,
        SourceCSVFileName: sourceCSVFileName,
        UploadedCSVFileName: uploadedCSVFileName,
        clientId: String(clientId),
         ...(id ? { BulkCampaignId: id } : {}),
        ...(selectedSeedList ? { SeedListId: selectedSeedList } : {}),
        ...(selectedSuppressionList ? { SuppressedListId: selectedSuppressionList } : {}),
      }).toString();

      return await http.post(`/bulkcampaign/uploadcsv?${query}`);
    }
  } catch (error) {
    throw error;
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addNewBulkCampaign = async (data: any) => {
    const response = await http.post(`/bulkcampaign/add`, data);
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllSeedList = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/seedlist/all?clientId=${clientId}` : '/seedlist/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllSuppressionList = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/suppressionlist/all?clientId=${clientId}` : '/suppressionlist/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}



// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getBulkEmailDetails = async (BulkCampaignDataIdentifier: string, selectedEmailTypes: string) => {
    let url = `/bulkcampaign/getuploadedcsvdata?BulkCampaignDataIdentifier=${BulkCampaignDataIdentifier}`;
    if (selectedEmailTypes && selectedEmailTypes != 'EmailsUploaded') {
        url += `&${selectedEmailTypes}=1`;
    }
    
    const response = await http.get(url);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getBulkEmailCampaignById = async (id: string) => {
    const response = http.get(`/bulkcampaign/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateBulkEmailCampaign = async (data: any) => {
     const response = await http.post(`/bulkcampaign/update`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const activateDeactivate = async (data: any) => {
     const response = await http.patch(`/bulkcampaign/activate`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteBulkEmailCampaign = async (data: any) => {
    const response = await http.delete(`/bulkcampaign/delete`, { data: data });
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const copyBulkEmailCampaign = async (campaignId: string,userdId: string) => {
    const response = await http.post(`/bulkcampaign/copy?id=${campaignId}&createdBy=${userdId}`);
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getBulkCampaignEndDate = async (data: string) => {
    const response = await http.post(`/bulkcampaignscheduler/calculateenddate`,data);
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getBulkCampaignGanttChart = async (data: any) => {
    const response = await http.post(`/bulkcampaignscheduler/ganttchartreport`,data);
    return response;
}